export const LAST_CHECK_SORT_DEFAULT = 'default';
export const LAST_CHECK_SORT_DESC = 'desc';
export const LAST_CHECK_SORT_ASC = 'asc';

export const LAST_CHECK_SORT_OPTIONS = [
  { value: LAST_CHECK_SORT_DEFAULT, label: 'Default order' },
  { value: LAST_CHECK_SORT_DESC, label: 'Last Check (newest first)' },
  { value: LAST_CHECK_SORT_ASC, label: 'Last Check (oldest first)' },
];

export const LAST_CHECK_SORT_LABELS = {
  [LAST_CHECK_SORT_DEFAULT]: 'Default order',
  [LAST_CHECK_SORT_DESC]: 'Last Check (newest first)',
  [LAST_CHECK_SORT_ASC]: 'Last Check (oldest first)',
};

export const cycleLastCheckSort = (current) => {
  if (current === LAST_CHECK_SORT_DEFAULT) return LAST_CHECK_SORT_DESC;
  if (current === LAST_CHECK_SORT_DESC) return LAST_CHECK_SORT_ASC;
  return LAST_CHECK_SORT_DEFAULT;
};

export const sortCandidatesByLastCheck = (candidates, sort) => {
  if (sort === LAST_CHECK_SORT_DEFAULT) return candidates;

  return [...candidates].sort((a, b) => {
    const aTime = a._original?.scraped_time
      ? new Date(a._original.scraped_time).getTime()
      : null;
    const bTime = b._original?.scraped_time
      ? new Date(b._original.scraped_time).getTime()
      : null;

    if (aTime === null && bTime === null) return 0;
    if (aTime === null) return 1;
    if (bTime === null) return -1;

    return sort === LAST_CHECK_SORT_DESC ? bTime - aTime : aTime - bTime;
  });
};
